import _ from 'lodash';

export default class AudienceRequirement extends Object {

    constructor(requirement) {
        super();
        _(this).keys().each(key => {
            if (requirement.hasOwnProperty(key)) {
                this[key] = requirement[key];
            }
        });
    }

    id = null;
    type = null;
    query_title = null;
    query_question = null;
    query_help_text = null;
    subcategory = null;
    subcategory_key = null;
    attributes = [];
    selectedAttributes = [];
    savedSelectedAttributes = [];
    max = null;
    min = null;
    savedMax = null;
    savedMin = null;

    updateSelectedAttributes(selectedAttributes) {
        switch (this.type) {
            case 'range':
                const maxAttribute = this.maxAttribute(),
                    minAttribute = this.minAttribute();
                selectedAttributes.forEach(attribute => {
                    if (!_.isObject(attribute)) {
                        return;
                    }
                    if (attribute.id == maxAttribute.id) {
                        this.max = attribute.value;
                    }
                    if (attribute.id == minAttribute.id) {
                        this.min = attribute.value;
                    }
                });
                this.savedMax = this.max;
                this.savedMin = this.min;

                if (_.isNull(this.max)) {
                    this.max = maxAttribute.max;
                }
                if (_.isNull(this.min)) {
                    this.min = minAttribute.min;
                }
                break;

            default:
                this.attributes.forEach(attribute => {
                    if (_.includes(selectedAttributes, attribute.id)) {
                        this.selectedAttributes.push(attribute.id)
                    }
                });
                this.savedSelectedAttributes = this.selectedAttributes;
                break;
        }

    }

    hasSavedAttributes() {
        switch (this.type) {
            case 'range':
                return !_.isNull(this.savedMax) || !_.isNull(this.savedMin);
            default:
                return this.savedSelectedAttributes.length > 0;
        }
    }

    hasSelectedAttributeToApply() {
        switch (this.type) {
            case 'range':
                return this.max !== this.savedMax || this.min !== this.savedMin;
            default:
                return !_.isEqual(this.selectedAttributes, this.savedSelectedAttributes);
        }
    }

    hasAttributesToRemove() {
        switch (this.type) {
            case 'range':
                return !_.isNull(this.savedMax) || !_.isNull(this.savedMin);
            default:
                return this.savedSelectedAttributes.length > 0;
        }
    }

    applySelectedAttributes(cb) {
        if (!this.hasSelectedAttributeToApply()) {
            return;
        }

        switch (this.type) {
            case 'range':
                this.savedMax = this.max;
                this.savedMin = this.min;
                if (cb) {
                    const maxAttribute = this.maxAttribute(),
                        minAttribute = this.minAttribute();
                    let attributes = [];
                    if (!_.isNull(this.savedMax)) {
                        attributes.push({
                            id: maxAttribute.id,
                            value: this.savedMax
                        });
                    }
                    if (!_.isNull(this.savedMin)) {
                        attributes.push({
                            id: minAttribute.id,
                            value: this.savedMin
                        });
                    }
                    cb(attributes, _.map(this.attributes, attribute => attribute.id));
                }
                break;
            default:
                this.savedSelectedAttributes = this.selectedAttributes;
                if (cb) {
                    cb(this.savedSelectedAttributes, _.map(this.attributes, attribute => attribute.id));
                }
                break;
        }
    }

    removeSelectedAttributes(cb) {
        switch (this.type) {
            case 'range':
                this.max = null;
                this.min = null;
                this.savedMax = this.max;
                this.savedMin = this.min;
                this.savedSelectedAttributes = [];
                if (cb) {
                    cb(_.map(this.attributes, attribute => attribute.id));
                }
                break;
            default:
                this.selectedAttributes = [];
                this.savedSelectedAttributes = this.selectedAttributes;
                if (cb) {
                    cb(_.map(this.attributes, attribute => attribute.id));
                }
                break;
        }
    }

    selectAllAttributes() {
        this.selectedAttributes = _.map(this.attributes, attribute => attribute.id);
    }

    maxAttribute() {
        return _.find(this.attributes, attribute => attribute.type === 'max')
    }

    minAttribute() {
        return _.find(this.attributes, attribute => attribute.type === 'min')
    }

    maxValues() {
        const maxAttribute = this.maxAttribute();

        return this._valuesRange(maxAttribute);
    }

    minValues() {
        const minAttribute = this.minAttribute();

        return this._valuesRange(minAttribute);
    }

    _valuesRange(attribute) {
        let values = [];
        if (!attribute) {
            return values;
        }

        for (let i = parseInt(attribute.min); i <= parseInt(attribute.max); i++) {
            values.push(i);
        }

        return values;
    }
}

